import { render } from "./CasinoLayout.vue?vue&type=template&id=cfb77260"
import script from "./CasinoLayout.vue?vue&type=script&lang=js"
export * from "./CasinoLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__